import { render, staticRenderFns } from "./companyClassify.vue?vue&type=template&id=a442f5dc&scoped=true"
import script from "./companyClassify.vue?vue&type=script&lang=js"
export * from "./companyClassify.vue?vue&type=script&lang=js"
import style0 from "./companyClassify.vue?vue&type=style&index=0&id=a442f5dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a442f5dc",
  null
  
)

export default component.exports